import { render, staticRenderFns } from "./POIManagedBoard.vue?vue&type=template&id=68c3af53"
import script from "./POIManagedBoard.js?vue&type=script&lang=js&external"
export * from "./POIManagedBoard.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports